import React, { Component } from "react";
import styles from "./App.module.scss";
import axios from "axios";
import { Carousel, WingBlank } from "antd-mobile";

const baseCdn = 'https://pudu-file-cdn.oss-accelerate.aliyuncs.com/website/hulu/static/';

const FirstVideo = baseCdn + 'H5FirstVideo.mp4';
const page2vid = baseCdn + 'page2vid.mp4';
const button = baseCdn + 'dong/button.png';
const hougai = baseCdn + 'dong/hougai.png';
const tuopan = baseCdn + 'dong/tuopan.png';
const ceshi = baseCdn + 'dong/ceshi.png';
const thankyou = baseCdn + 'thankyou.png';

class App extends Component {
  constructor(props) {
    super(props);
    this.fileref = React.createRef();
  }
  state = {
    data: ["1", "2", "3"],
    imgHeight: 176,
    x: 40.55,
    radioIndex: 0,
    isNotFill: false,
    pages: [
      {
        id: 0,
        src: "preSale.png",
      },
      {
        id: 1,
        src: "largeScreen.png",
      },
      {
        id: 2,
        src: "lake.png",
      },
      {
        id: 3,
        src: "yingBing.png",
      },
      {
        id: 4,
        src: "banner.png",
      },
      {
        id: 5,
        src: "diaoDu.png",
      },
      {
        id: 6,
        src: "yuDing.png",

        single: [
          "Purchose Product", //采购产品 2
          "To Be a Distributor", //做经销商 3
          "Business Cooperation", //商业合作 4
        ],
      },
    ],
    positionX: null,
    animation: null,
    userPushDoWhat: 2, //默认为采购产品 2
    inputName: [
      {
        id: 1,
        name: "Name",
        val: "",
        isRequire: true,
        isWarning: false,
      },
      {
        id: 2,
        name: "Cell Phone", //电话
        val: "",
        isRequire: true,
        isWarning: false,
      },
      {
        id: 3,
        name: "Company Name", //公司名
        val: "",
        isRequire: true,
        isWarning: false,
      },
      {
        id: 4,
        name: "Country/Region", //国家地区
        val: "",
        isRequire: true,
        isWarning: false,
      },
      {
        id: 5,
        name: "Email", //邮箱
        val: "",
        isRequire: true,
        isWarning: false,
      },
      {
        id: 6,
        name: "WhatsAPP/ WeChat/ Skype", 
        val: "",
        isRequire: false,
      },
      {
        id: 7,
        name: "Message", 
        val: "",
        isRequire: false,
      },
    ],
  };

  shouldSetIsFill(){
    if(!this.state.isNotFill) return;
    let flag = false;
    this.state.inputName.forEach(item => {
      if(!item.val && item.isRequire) flag = true;
    })
    if(!flag) this.setState({isNotFill: false})
  }

  haodleIuputValue = (index, e) => {
    if (index === 0) {
      const inputName = [...this.state.inputName];
      this.setState({
        inputName: inputName.map((v, i) =>
          i === index ? { ...v, val: e.target.value, isWarning: false } : v
        ),
      }, this.shouldSetIsFill);
    } else if (index === 1) {
      const inputName = [...this.state.inputName];
      let number = e.target.value.replace(/[^\d]/g,'')
      this.setState({
        inputName: inputName.map((v, i) =>
          i === index ? { ...v, val: number, isWarning: false } : v
        ),
      }, this.shouldSetIsFill);
    } else if (index === 2) {
      const inputName = [...this.state.inputName];
      this.setState({
        inputName: inputName.map((v, i) =>
          i === index ? { ...v, val: e.target.value, isWarning: false } : v
        ),
      }, this.shouldSetIsFill);
    } else if (index === 3) {
      const inputName = [...this.state.inputName];
      this.setState({
        inputName: inputName.map((v, i) =>
          i === index ? { ...v, val: e.target.value, isWarning: false } : v
        ),
      }, this.shouldSetIsFill);
    } else if (index === 4) {
      const inputName = [...this.state.inputName];
      this.setState({
        inputName: inputName.map((v, i) =>
          i === index ? { ...v, val: e.target.value, isWarning: false } : v
        ),
      }, this.shouldSetIsFill);
    } else if (index === 5) {
      const inputName = [...this.state.inputName];
      this.setState({
        inputName: inputName.map((v, i) =>
          i === index ? { ...v, val: e.target.value } : v
        ),
      });
    } else if (index === 6) {
      const inputName = [...this.state.inputName];
      this.setState({
        inputName: inputName.map((v, i) =>
          i === index ? { ...v, val: e.target.value } : v
        ),
      });
    }
  };
  getRadioIndexAndDowhat(val, index) {
    let doWhat;
    switch(val){
      case 'Purchose Product' :
        doWhat = 2;
        break;
      case 'To Be a Distributor' :
        doWhat = 3;
        break;
      case 'Business Cooperation' :
        doWhat = 4;
        break;
        default:return;
    }
    this.setState({
      radioIndex: index,
      userPushDoWhat: doWhat,
    });
  }

  mousedown = (e) => {
    this.dragging = true;
    this.elementX = e.touches[0].clientX - e.touches[0].target.offsetLeft;
    console.log("按下");
  };
  mousemove = (e) => {
    console.log(this.dragging);
    if (this.dragging === false) {
      return;
    }
    if (
      e.touches[0].clientX - this.elementX <
      window.innerWidth - e.touches[0].target.offsetWidth
    ) {
      this.setState({
        positionX: e.touches[0].clientX - this.elementX,
      });
    } else {
      console.log("触发托盘");
      this.setState({
        positionX: e.touches[0].clientX - this.elementX,
      });
      this.setState({
        animation: true,
      });
    return;
    }
    if (e.touches[0].clientX - this.elementX > this.initial) {           
      this.setState({
        positionX: e.touches[0].clientX - this.elementX,
      });
    } else {
      this.setState({
        animation: false,
        positionX: this.initial,
      });
    }
  };
  mouseup = (e) => {
    console.log()
    if (e.target.offsetLeft >
      window.innerWidth - e.target.offsetWidth) { 
       let i = this.state.positionX
      let time = setInterval(()=>{
        this.setState({
          positionX: i++
        });
        if(i>window.innerWidth){
          clearInterval(time)
        }
      },10)

    } 
    this.dragging = false;
  };
  haodleSubmit() {
    const { inputName, userPushDoWhat } = this.state;
    if(!inputName[0].val || !inputName[1].val || !inputName[2].val || !inputName[3].val || !inputName[4].val){
      let newinputName = inputName;
      newinputName.forEach((item, index) => {
        if(!item.val && item.isRequire) item.isWarning = true
      })
      this.setState({isNotFill: true, inputName: newinputName})
      return;
    }else{
      this.setState({isNotFill: false})
    }
    axios
      .post("/api/v1/front/cooperate", {
        name: inputName[0].val,
        mobile: inputName[1].val,
        cooperation_type: userPushDoWhat,
        company: inputName[2].val,
        proxy_region: inputName[3].val,
        email: inputName[4].val,
        weixin: inputName[5].val,
        remark: inputName[6].val,
        source: "葫芦预售H5",
      })
      .then((res) => {
        console.log(res);
        if (res) {
          this.setState({
            eject: true,
          });
        }
      });
  }

  haodleEject(){
    let newData = this.state.inputName.map(item => {
      if(item.isRequire){
        return {...item, val: '', isWarning: false}
      }else{
        return {...item, val: ''}
      }
    })
    
    this.setState({
      eject: false,
      inputName: newData,
    });
  }
  render() {
    const { positionX } = this.state;
    const style = {
      left: positionX + "px",
    };

    return (
      <div>
        <div className={styles.eject_and_form} style={{display:this.state.eject === true ? "block":"none"}}>
                      <img
                        src={thankyou}
                        className={styles.eject_image}
                        alt=""
                      />
                      <div className={styles.blackHome} onClick={()=>{this.haodleEject()}}>BACK</div>
                    </div>
        <div
          className={styles.header}
        >
 
          <WingBlank>
            <Carousel
             ref={el => (this.slider = el)}
              className="my-carousel"
              vertical
            >
              {this.state.pages.map((v) => {
                return (
                  <div>
                    

                    <div className={styles.header_box} key={v.id}>
                      {v.id === 0 ? (
                        <video
                          className={styles.page1_video}
                          style={{ height: "26vh" }}
                          src={FirstVideo}
                          autoplay="autoplay"
                          controls
                          muted={true}
                          webkit-playsinline="true" 
                          playsinline="true"
                        />
                      ) : null}
                      {v.id === 1 ? (
                        <video
                          className={styles.page2_video}
                          src={page2vid}
                          autoplay="autoplay"
                          muted={true}
                          webkit-playsinline="true" 
                          playsinline="true"
                          loop
                        />
                      ) : null}
                      {v.id === 4 ? ( //拉拽动画页
                        <div className={styles.hulu_animation_box}>
                          <img
                            style={style}
                            ref={this.fileref}
                            src={button}
                            className={styles.hulu_animation_button}
                            alt=""
                          />
                          <img
                            src={hougai}
                            className={
                              this.state.animation
                                ? `${styles.hulu_animation_hougai} ${styles.hulu_animation_hougai_active}`
                                : `${styles.hulu_animation_hougai}`
                            }
                            alt=""
                          />
                          <img
                            src={tuopan}
                            className={
                              this.state.animation
                                ? `${styles.hulu_animation_tuopan} ${styles.hulu_animation_tuopan_active}`
                                : `${styles.hulu_animation_tuopan}`
                            }
                            alt=""
                          />
                          <img
                            src={ceshi}
                            className={styles.hulu_animation_ceshi}
                            alt=""
                          />
                        </div>
                      ) : null}

                      {v.id === 6 ? ( //表单页单选按钮
                        <div className={styles.huluform_box_max}>
                          <div className={styles.huluform_box}>
                            {v.single.map((val, index) => {
                              return (
                                <div
                                  className={styles.huluform_box_item}
                                  key={index}
                                  style={{
                                    background:
                                      this.state.radioIndex === index
                                        ? "#de9c1a"
                                        : "",
                                    borderColor:
                                      this.state.radioIndex === index
                                        ? "#de9c1a"
                                        : "",
                                  }}
                                  onClick={() => {
                                    this.getRadioIndexAndDowhat(val, index);
                                  }}
                                >
                                  <div>{val}</div>
                                </div>
                              );
                            })}
                          </div>
                          <div className={styles.huluform_inputForm_box}>
                            {this.state.inputName.map((vx, i) => {
                              return (
                                <div className={styles.inputItem}>
                                  {vx.isRequire && (
                                    <span>
                                      *
                                    </span>
                                  )}
                                  <input
                                    value={vx.val}
                                    onChange={(e) => {
                                      this.haodleIuputValue(i, e);
                                    }}
                                    key={vx.id}
                                    className={styles.inputForm}
                                    placeholder={vx.name}
                                    style={{outline: `${vx.isWarning ? 'red solid 1px' : 'none'}`}}
                                  />
                                </div>
                              );
                            })}
                            {this.state.isNotFill && (
                              <div className={styles.warnText}>Please fill out the information</div>
                            )}
                            <div
                              className={styles.huluSubmit}
                              onClick={() => {
                                this.haodleSubmit();
                              }}
                            >
                              Submit
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <img //全部页面背景
                        className={styles.header_image}
                        src={baseCdn + v.src}
                        alt=""
                      />
                      <img
                        className={styles.header_bottom}
                        src={baseCdn + 'down.svg'}
                        alt=""
                      />
                    </div>
                  </div>
                );
              })}
            </Carousel>
          </WingBlank>
        </div>
      </div>
    );
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        data: [
          "AiyWuByWklrrUDlFignR",
          "TekJlZRVCjLFexlOCuWn",
          "IJOtIlfsYdTyaDTRVrLI",
        ],
      });
    }, 100);
    console.log(window.innerWidth);
    /*  this.root = document.getElementById("root");*/
    this.initial = this.fileref.current.offsetLeft;
    this.fileref.current.addEventListener("touchstart", this.mousedown);
    this.fileref.current.addEventListener("touchmove", this.mousemove);
    this.fileref.current.addEventListener("touchend", this.mouseup);
    /* this.root.addEventListener("touchend", this.mousedown) */

    /* '/v1/front/cooperate': {
                  post: {
                    summary: '商务合作',
                    tags: [ 'Front' ],
                    parameters: {
                      body: Joi.object().keys({
                        name: Joi.string().required().description('姓名'),
                        mobile: Joi.string().empty('').description('手机号'),
                        weixin: Joi.string().empty('').optional().description('微信号'),
                        email: Joi.string().empty('').optional().description('邮箱'),
                        company: Joi.string().empty('').description('公司'),
                        position: Joi.string().empty('').description('职务'),
                        company_location: Joi.string().empty('').optional().description('公司所在位置信息'),
                        proxy_region: Joi.string().empty('').optional().description('意向代理区域'),
                        cooperate_intention: Joi.string().empty('').optional().description('合作意向'),
                        cooperation_type: Joi.number().valid(1, 2, 3, 4, 5).required().description('合作类型 1 其他 2 购买产品 3 区域代理 4 品牌合作 5消毒预售'),
                        intended_purchase_area: Joi.string().empty('').optional().description('意向购买区域'),
                        source: Joi.string().empty('').optional().description('来源'),
                        remark: Joi.string().empty('').optional().description('备注'),
                      }),
                    }, */
    /* 

            this.root.addEventListener("touchstart", this.handleTouchStart); */
    /*console.log(this.state.pages);
                 console.log(document.body.scrollTop);
                 console.log(this.state.offsetheight); 
                 this.root.addEventListener("touchend", this.handleTouchEnd);*/
    /*  this.root.addEventListener("touchmove", this.handleTouchMove); */
  }
}

export default App;
